const KEY = "haakuvatunkki.token";

export function readStoredToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function storeToken(token: string): void {
  window.localStorage.setItem(KEY, token);
}

export function clearToken(): void {
  window.localStorage.removeItem(KEY);
}

/**
 * Extract a token from the current URL (?t=...) and clean the URL.
 * Returns the token if present, else null.
 */
export function consumeUrlToken(): string | null {
  const url = new URL(window.location.href);
  const t = url.searchParams.get("t");
  if (!t) return null;
  url.searchParams.delete("t");
  window.history.replaceState({}, "", url.pathname + (url.search ? "?" + url.searchParams : ""));
  return t;
}

/** Try URL first, then localStorage. Returns the resolved token or null. */
export function resolveInitialToken(): string | null {
  const fromUrl = consumeUrlToken();
  if (fromUrl) {
    storeToken(fromUrl);
    return fromUrl;
  }
  return readStoredToken();
}
